import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import { KEY_CONTENT_ROUTES } from 'routing';
import tutorRating from 'static/img/home/tutor-rating.svg';
import AnimatedContainer from 'components/AnimatedContainer';
import { topTutors, topSubjects } from '../../constants/topSubjects';

import css from './TopTutorsSubjects.module.scss';

function TopTutorsSubjects() {
  return (
    <div className={css.wrapper}>
      <div className="container">
        <AnimatedContainer>
          <h2 className={css.topTutorsTitle}>
            Our online tutors are trusted by parents and recommended by students
          </h2>
        </AnimatedContainer>
        <Link to={KEY_CONTENT_ROUTES.SEARCH_RESULTS}>
          <AnimatedContainer className={css.topTutorList}>
            {topTutors.map(
              ({ title, image, subject, price, mobilePrice, experience }) => (
                <div key={title} className={css.topTutorItem}>
                  <LazyLoad>
                    <img
                      className={css.topTutorItemImage}
                      src={image}
                      alt={title}
                    />
                  </LazyLoad>

                  <h3 className={css.topTutorItemName}>{title}</h3>
                  <p className={css.topTutorItemDescr}>{subject}</p>
                  <LazyLoad>
                   <img className={css.rating} src={tutorRating} alt="5-stars" />
                  </LazyLoad>
                  <div className={css.topTutorItemLessons}>
                    <span>{experience * 50}+</span>
                    Lessons completed
                  </div>
                  <div className={css.topTutorItemExperience}>
                    {experience} years experience
                  </div>
                  <div className={css.topTutorItemPrice}>
                    {mobilePrice && (
                      <span className={css.priceMobile}>£{mobilePrice}</span>
                    )}
                    <span
                      className={cn(css.priceDesctop, {
                        [css.hasMobilePrice]: mobilePrice
                      })}
                    >
                      £{price}
                    </span>
                    /per hour
                  </div>
                </div>
              )
            )}
          </AnimatedContainer>
        </Link>
        <div className={css.topTutorsLink}>
          <a className="btn-home" rel="noopener noreferrer" href={KEY_CONTENT_ROUTES.SEARCH_RESULTS}>
            Find a tutor
          </a>
        </div>
        <AnimatedContainer className={css.subjectsListWrap}>
          <h2 className={css.subjectsTitle}>Top Subjects</h2>
          <ul className={css.subjectsList}>
            {topSubjects.map(({ title, link }) => (
              <li key={link} className={css.subjectsListItem}>
                <a href={`//tutorhouse.co.uk${link}`}>{title}</a>
              </li>
            ))}
          </ul>
        </AnimatedContainer>
      </div>
    </div>
  );
}

export default TopTutorsSubjects;
